export default defineNuxtPlugin(() => {
  const addOSClass = () => {
    let os = '';

    if (navigator.userAgentData) {
      navigator.userAgentData
        .getHighEntropyValues(['platform'])
        .then(ua => {
          os = ua.platform.toLowerCase();
          applyClass(os);
        })
        .catch(() => fallback());
    } else {
      fallback();
    }

    function fallback() {
      const platform = navigator.platform.toLowerCase();
      const ua = navigator.userAgent.toLowerCase();

      if (platform.includes('mac') || ua.includes('macintosh')) {
        os = 'mac';
      } else if (platform.includes('win') || ua.includes('windows')) {
        os = 'windows';
      } else {
        os = 'other';
      }
      applyClass(os);
    }

    function applyClass(os: string) {
      document.documentElement.classList.add(`is-${os}`);
      document.body.classList.add(`is-${os}`);
    }
  };

  // 等 DOM 渲染完成再加 class
  if (process.client) {
    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', addOSClass);
    } else {
      addOSClass();
    }
  }
});
